import { FiStateNames } from '../../shared/fi-state-proxy/fi-state-names';
import { StatesModule, Transition } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { FiTransferOwnershipComponent } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership/fi-transfer-ownership.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';

const TransferOwnershipState = {
    name: FiStateNames.OtherSettings.TransferOwnership,
    url: '/TransferOwnership',
    views: {
        '@': {
            component: FiTransferOwnershipComponent,
        },
    },
    params: {
        sourceUserId: undefined,
    },
    resolve: {
        sourceUserId: [FiStateService, Transition, getSourceUserId],
    },
};
export function getSourceUserId(fiStateService: FiStateService, transition: Transition): number {
    return coerceNumberProperty(fiStateService.getParams(transition).sourceUserId);
}

export const TransferOwnershipStates: StatesModule = {
    states: [TransferOwnershipState],
};

export function registerTransferOwnershipStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.TransferOwnership], {
        SettingType: [ApplicationSettingsType.CoreGlobal],
        AccessType: AccessRightType.Admin,
    });
}
